// extracted by mini-css-extract-plugin
export default {"wrapper_input":"styles_wrapper_input__2HRgR","input":"styles_input__H1r3F","buttonDeleteSearch":"styles_buttonDeleteSearch__ZphZx"};